import { render, staticRenderFns } from "./AppleHunterPage.vue?vue&type=template&id=085f638c&scoped=true"
import script from "./AppleHunterPage.vue?vue&type=script&lang=ts"
export * from "./AppleHunterPage.vue?vue&type=script&lang=ts"
import style0 from "./AppleHunterPage.vue?vue&type=style&index=0&id=085f638c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f638c",
  null
  
)

export default component.exports